import logo from './logo.svg';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Layout from '../src/components/Layout';

function App() {
  return (
    <Layout/>
  );
}

export default App;
